import styled from "styled-components";
export default styled.p(["color:", ";margin:0 0 32px;max-width:75ch;&:empty{margin:0;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.paragraph.color;
});